import { render, staticRenderFns } from "./decision1.vue?vue&type=template&id=03f6f438&scoped=true"
import script from "./decision1.vue?vue&type=script&lang=js"
export * from "./decision1.vue?vue&type=script&lang=js"
import style0 from "./decision1.vue?vue&type=style&index=0&id=03f6f438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6f438",
  null
  
)

export default component.exports